import React from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../../store/ApplicationStore";
import { FiltersData as BookingTolerancesFiltersData } from "../../store/state/BookingTolerances/FiltersData";
import { TableData as BookingTolerancesTableData } from "../../store/state/BookingTolerances/TableData";
import { BookingTolerancesFiltersActions as ActionClassFilters } from "../../store/actions/BookingTolerances/FiltersActions";
import { DEFAULT_PATHS } from "../../utils/ApiUtils";
import {
  ActionOptions,
  Autosuggests,
  BindProperties,
  Buttons,
  Checkboxes,
  ConfigurationMethods,
  Containers,
  Inputs,
  SectionKeys,
  Selects,
  TableColumns,
} from "../../utils/Constants";
import { IHistory } from "../../store/state/History";
import { RouteComponentProps } from "react-router";
import FiltersTableLayoutsWrapperV2 from "../../layout/FiltersTableLayouts/FiltersTableLayoutsWrapperV2";
import { CustomColumnProps, IRow } from "../../layout/EditorLayout/EditorLayout";
import { CATEGORIES } from "../../utils/PermissionsChecker";
import { BookingTolerancesTableActions as ActionClassTable } from "../../store/actions/BookingTolerances/TableActions";
import { BookingTolerancesEditorActions as ActionClassEditor } from "../../store/actions/BookingTolerances/EditorActions";
import { EntityType } from "../../integrated-client";

interface IBookingTolerancesProps {
  bookingTolerancesFiltersData: BookingTolerancesFiltersData;
  bookingTolerancesTableData: BookingTolerancesTableData;
}

const BookingTolerances: React.FC<
  IBookingTolerancesProps & IHistory & RouteComponentProps
> = (props) => {
  const { bookingTolerancesFiltersData, bookingTolerancesTableData, history } =
    props;

  const rows: Array<IRow> = [
    {
      index: 0,
      items: [
        {
          id: Selects.BrandAndMarket as never,
          type: "select",
          label: "Brand and Market",
          allowClear: true,
          configurationProperty: "brandsAndMarkets",
        },
        {
          id: Selects.DistributionChannel as never,
          type: "select",
          label: "Distribution Channel",
          allowClear: true,
          configurationProperty: "distributionChannels",
        },
        {
          id: Selects.Supplier as never,
          type: "select",
          label: "Supplier",
          allowClear: true,
          configurationProperty: "suppliers",
        },
        {
          id: Autosuggests.Carrier as never,
          type: "autoSuggest",
          label: "Carrier",
          allowClear: true,
        },
      ],
    },
    {
      index: 1,
      items: [
        {
          id: Selects.Relevance as never,
          type: "select",
          label: "Relevance",
          allowClear: true,
          configurationProperty: "relevances",
        },
        {
          id: Inputs.Description as never,
          type: "input",
          label: "Description",
          allowClear: true,
        },
        {
          id: Containers.ShowBlock as never,
          type: "container",
          label: "Show:",
          innerItems: [
            {
              id: Checkboxes.ShowDeleted as never,
              type: "checkbox",
              label: "Deleted",
            },
            {
              id: Checkboxes.ShowDisabled as never,
              type: "checkbox",
              label: "Disabled",
            },
          ],
        },
        {
          id: Containers.ButtonsBlock as never,
          type: "container",
          span: "6",
          innerItems: [
            {
              id: Buttons.Clear as never,
              type: "button",
              buttonType: Buttons.Clear,
              label: "Clear all",
            },
            {
              id: Buttons.Search as never,
              type: "button",
              buttonType: Buttons.Search,
              label: "Search",
            },
          ],
        },
      ],
    },
  ];

  const columns: Array<CustomColumnProps> = [
    { title: "Description", dataIndex: TableColumns.Description, width: 250, sorter: false },
    { title: "Comment", dataIndex: TableColumns.Comment, width: 250, sorter: false },
    { title: "Brand and Market", dataIndex: TableColumns.BrandAndMarket, width: 250, sorter: false },
    { title: "Distribution Channel", dataIndex: TableColumns.DistributionChannels, width: 200, sorter: false },
    { title: "Supplier", dataIndex: TableColumns.Suppliers, width: 200, sorter: false },
    { title: "Relevance", dataIndex: TableColumns.Relevance, width: 130, sorter: false },
  ];

  return (
    <FiltersTableLayoutsWrapperV2
      layoutFilters={{
        title: "Search parameters",
        rows: rows,
        filtersData: bookingTolerancesFiltersData,
        actionClassFilters: ActionClassFilters,
        actionClassEditor: ActionClassEditor,
        configurationMethod: ConfigurationMethods.BookingTolerancesList,
      }}
      layoutTable={{
        columns: columns,
        tableData: bookingTolerancesTableData,
        actionClassTable: ActionClassTable,
        historyType: EntityType.BookingToleranceUpdate,
        addButtonName: "Add Booking Tolerance",
        actionOptions: {
          whenFullControl: [
            ActionOptions.View,
            ActionOptions.Edit,
            ActionOptions.Copy,
            ActionOptions.History,
            ActionOptions.Delete,
          ],
          whenReadOnly: [ActionOptions.View, ActionOptions.History],
        },
      }}
      sectionKey={SectionKeys.BookingTolerances}
      path={`${DEFAULT_PATHS.BOOKING_TOLERANCES}/rule`}
      menuListProperty={"brandsAndMarkets" as never}
      actionClassEditor={ActionClassEditor}
      bindProperty={BindProperties.BrandAndMarket}
      category={CATEGORIES.BOOKING_TOLERANCES}
      history={history}
      entityType={EntityType.BookingToleranceUpdate}
    />
  );
};

const mapStateToProps = function (
  state: ApplicationState
): IBookingTolerancesProps {
  const {
    filtersData: bookingTolerancesFiltersData,
    tableData: bookingTolerancesTableData,
  } = state.bookingTolerances;
  return { bookingTolerancesFiltersData, bookingTolerancesTableData };
};

export default connect(mapStateToProps)(BookingTolerances);
